var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDivitmiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25.002,
    viewBox: "0 0 25 25.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25848",
    "data-name": "Group 25848",
    transform: "translate(-61.111 -268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25847",
    "data-name": "Group 25847",
    transform: "translate(61.111 268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37373",
    "data-name": "Path 37373",
    d: "M13.193,25.694a12.5,12.5,0,1,1,12.5-12.5A12.515,12.515,0,0,1,13.193,25.694Zm0-23.778A11.277,11.277,0,1,0,24.47,13.193,11.29,11.29,0,0,0,13.193,1.916Z",
    transform: "translate(-0.693 -0.692)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25846",
    "data-name": "Group 25846",
    transform: "translate(6.092 4.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37374",
    "data-name": "Path 37374",
    d: "M12.553,21.314,8.366,18.9v-3.47h3.964v1.439l5.08-2.933L12.329,11v1.439H8.366V8.969l4.187-2.417,8.6,4.963V16.35Z",
    transform: "translate(-7.754 -5.941)",
    fill: "#ffb299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37375",
    "data-name": "Path 37375",
    d: "M12.464,21.836a.617.617,0,0,1-.306-.081L7.972,19.338a.611.611,0,0,1-.306-.529V15.339a.611.611,0,0,1,.612-.612h3.964a.611.611,0,0,1,.612.612v.38L16.1,13.845l-3.245-1.874v.38a.611.611,0,0,1-.612.612H8.278a.611.611,0,0,1-.612-.612V8.881a.613.613,0,0,1,.306-.53l4.187-2.417a.61.61,0,0,1,.611,0l8.6,4.963a.614.614,0,0,1,.307.53v4.835a.611.611,0,0,1-.307.529l-8.6,4.963A.609.609,0,0,1,12.464,21.836ZM8.889,18.454l3.575,2.065,7.985-4.611V11.78L12.464,7.17,8.889,9.234v2.5H11.63v-.827a.612.612,0,0,1,.917-.529l5.079,2.933a.61.61,0,0,1,0,1.059l-5.079,2.934a.612.612,0,0,1-.917-.53V15.95H8.889Z",
    transform: "translate(-7.666 -5.852)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDivitmiles);
export default __webpack_public_path__ + "static/media/icon-divitmiles.2f3617158de4d8d0d984337fc4e2b054.svg";
export { ForwardRef as ReactComponent };